import {UploadFileWrapper} from "../UploadFileWrapper/UploadFileWrapper";
import {AuthRequest} from "../AuthRequest/AuthRequest";

export class EnviarDocumentosRequest extends AuthRequest {

  tipoSolicitud: string;
  idSolicitud: string;
  files: UploadFileWrapper[];

  constructor(
    tramiteTipo: string,
    tramiteNumero: string,
    tokenRecaptcha: string,
    files: UploadFileWrapper[]
  ) {
    super(tokenRecaptcha);
    this.tipoSolicitud = tramiteTipo;
    this.idSolicitud = tramiteNumero;
    this.files = files;
  }
}
